import { ValidatorInput } from '../validation/validation-descriptor.entity';
import { UserValidator } from '../validation/validation.user';
import { ValidationChecks } from '../validation/validation-checks.enum';
import { NutzerAnlageRequest, NutzerAnlageResponse } from '../../../generated/api/kreditportalBackendAPI.schemas';
import { Validator } from '../validation/validator.util';
import { ValidationError } from '../validation/validation.error';
import { TypedChangingEntityFactory } from '../typed-changing-entity-factory';

export class UserCreateModel {

    private checkEmail = (field: ValidatorInput) => {
        UserValidator.validateAndDoubleCheckEmail(field, this.email.value);
    };

    url: string;

    vsnr: string;
    neueNutzerId: string;

    vorname = new ValidatorInput(
        'vorname',
        '',
        'Vorname',
        /^\w+$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK
    );

    nachname = new ValidatorInput(
        'nachname',
        '',
        'Name',
        /^\w+$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK
    );

    email = new ValidatorInput(
        'email',
        '',
        'E-Mail-Adresse',
        /^.$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK,
        UserValidator.validateSingleEmail,
    );

    emailConfirm = new ValidatorInput(
        'emailConfirm',
        '',
        'E-Mail-Adresse-Wiederholung',
        /^.$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK,
        this.checkEmail,
    );

    collection: ValidatorInput[] = [
        this.vorname,
        this.nachname,
        this.email,
        this.emailConfirm,
    ];

    mapResponse(response: NutzerAnlageResponse): void {
        if (!response.nachname.validationResult) {
            this.mapError(this.nachname);
        }

        if (!response.vorname.validationResult) {
            this.mapError(this.vorname);
        }

        if (!response.email.validationResult) {
            this.mapError(this.email);
        }
    }

    mapError(input: ValidatorInput) {
        input.valid = false;
        input.errorMsg = Validator.MSG_ON_REGEX_FAIL
            .replace('$_label', input.label)
            .replace('$_value', input.value);
    }

    validateField(field: ValidatorInput) {
        field.valid = Validator.doValidate(field, 1, []);
    }

    validate(untilLabel = 'never stop(dummy)'): ValidationError[] {
        const result: ValidationError[] = [];

        for (const field of this.collection) {
            field.valid = Validator.doValidate(field, 1, result);

            if (field.name === untilLabel) {
                break;
            }
        }

        return result.length === 0 ? null : result;
    }

    forRequest = (): NutzerAnlageRequest => {
        return {
            vsnr: this.vsnr,
            neueNutzerId: this.neueNutzerId,
            url: this.url,
            vorname: TypedChangingEntityFactory.createByValue(this.vorname.value),
            nachname: TypedChangingEntityFactory.createByValue(this.nachname.value),
            email: TypedChangingEntityFactory.createByValue(this.email.value)
        }
    };

}
